<div
  class="alert"
  [style.background-color]="'var(--' + backgroundColor() + ')'"
  [style.color]="'var(--' + color() + ')'"
  [style.border]="border()"
  [style.padding]="padding()"
  [style.width]="width()"
  [style.justify-content]="justifyContent()">
  @if (icon()) {
    <img class="icon" [src]="icon()" alt="title" />
  }
  <div>
    <h2
      class="title"
      [class.hasDescription]="isDescriptionShown()"
      [style.font-size]="titleFontSize()"
      [style.font-weight]="titleFontWeight()">
      <span>{{ title() }}</span>
      <div class="total-value">
        @if (currency()) {
          <span
            [style.font-family]="
              (currency() | currencySymbol)?.isSar ? 'saudi_riyal' : null
            ">
            {{ (currency() | currencySymbol)?.symbol }}
          </span>
        }
        <span>
          @if (totalValue()) {
            <span>{{ totalValue() }}</span>
          }
        </span>
      </div>
    </h2>
    @if (isDescriptionShown()) {
      <p class="description">
        @if (errorMessage()) {
          <span class="error-message p-small">{{ errorMessage() }}</span>
        }
        <ng-content></ng-content>
      </p>
    }
  </div>
</div>
